import { useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PageTitle from "../../../components/common/PageTitle";
import AdminNavbar from "../../../components/layouts/AdminNavbar";
import { CenteredLayout } from "../../../components/layouts";
import ResourceAllocationSummaryList from "../../../components/layouts/ResourceAllocationSummaryList";
import useResourceAllocationSummary from "../../../hooks/useResourceAllocationSummary";
import { getCurrentCalendarPeriod, monthNames } from "../../../utils/consts";
import type { IResourceAllocationSummaryRowApi } from "../../../services/types/resourceAllocation";

const ResourceAllocation = () => {
  const history = useHistory();
  const location = useLocation();
  const initialPeriod = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const year = parseInt(params.get("year") ?? "", 10);
    const month = parseInt(params.get("month") ?? "", 10);
    if (Number.isFinite(year) && Number.isFinite(month) && month >= 1 && month <= 12) {
      return { month: monthNames[month - 1], year };
    }
    return getCurrentCalendarPeriod();
  }, [location.search]);

  const [{ month: selectedMonth, year: selectedYear }, setPeriod] = useState(initialPeriod);

  const setSelectedMonth = (month: string) =>
    setPeriod((prev) => ({ ...prev, month }));
  const setSelectedYear = (year: number) =>
    setPeriod((prev) => ({ ...prev, year }));

  const {
    rows,
    isLoading,
    acceptSettlement,
    rejectSettlement,
    monthIndex,
  } = useResourceAllocationSummary(selectedMonth, selectedYear);

  const handleRowClick = (row: IResourceAllocationSummaryRowApi) => {
    const month = monthIndex >= 0 ? monthIndex + 1 : 1;
    history.push({
      pathname: `/resource-allocation/${row.employeeId}`,
      search: `?year=${selectedYear}&month=${month}`,
      state: {
        employeeName: `${row.lastName} ${row.firstName}`,
      },
    });
  };

  return (
    <>
      <AdminNavbar />
      <CenteredLayout>
        <PageTitle title="Alokacja zasobów" />
        <div className="table-container">
          <ResourceAllocationSummaryList
            rows={rows}
            isLoading={isLoading}
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            setSelectedMonth={setSelectedMonth}
            setSelectedYear={setSelectedYear}
            acceptSettlement={acceptSettlement}
            rejectSettlement={rejectSettlement}
            onRowClick={handleRowClick}
          />
        </div>
      </CenteredLayout>
    </>
  );
};

export default ResourceAllocation;
